export default {
  // Page Title
  title: "Monitor Dynamics",

  // Filters
  transactionDirection: "Transaction Direction",
  inputCounterpartyAddress: "Enter counterparty address",
  minAmount: "Min Amount",
  maxAmount: "Max Amount",
  maxAmountTip: "Max amount must be ≥ min amount",

  // Transaction Direction Options
  outflow: "Outflow",
  inflow: "Inflow",
  bidirectional: "Bidirectional",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Statistics
  currentChain: "Current address chain:",
  totalCount: "Total",
  totalDynamics: "monitor dynamics",
  unread: "unread",
  markAllRead: "Mark all as read",

  // Table Columns
  transactionTime: "Transaction Time",
  sender: "Sender",
  receiver: "Receiver",
  currency: "Currency",
  transactionQuantity: "Transaction Quantity",
  transactionHash: "Transaction Hash",
  operation: "Operation",

  // Address
  currentAddress: "Current Address",

  // Operation Buttons
  markRead: "Mark as Read",
  addToMonitor: "Add to Monitor",
  addToCanvas: "Add to Canvas",

  // Dialog
  dialogAddMonitor: "Add Monitor",
  monitorAddSuccess: "Address monitoring added successfully",
  return: "Return",
  viewMonitor: "View Monitor",

  // Messages
  loading: "Loading...",
  noData: "No data available",
  copySuccess: "Copied successfully!",
};
